// extracted by mini-css-extract-plugin
export default {"image-viewer":"ImageViewer_image-viewer__QmksI","content":"ImageViewer_content__ylLFu","image":"ImageViewer_image__Ys1Wf","btn-close":"ImageViewer_btn-close__0+xEB"};